import type { ComponentType } from "react";

import type { QRProps } from "@/contexts/QREditorContext/types";
import type { QRDataType, QRType } from "@/types/qr";

export type { QRProps } from "@/contexts/QREditorContext/types";
export type { QRDataType, QRType } from "@/types/qr";
export { PreviewSource } from "@/components/QRPreview/types";

/**
 * Baseline props for a single QR preview (editor or view page).
 */
export type PreviewComponentProps<T extends QRDataType = QRDataType> = QRProps<T>;

/**
 * Registry entry for a legacy or migrated preview.
 * Uses a wide props type so concrete preview components remain assignable during migration.
 */
export type PreviewComponent = ComponentType<QRProps<QRDataType>>;

/** String keys in the preview registry must align with `data.type` / {@link QRType}, plus "empty" for the UI fallback state. */
export type PreviewRegistryKey = QRType | "empty";

/**
 * Function that returns the initial data for a preview.
 */
export type InitDataGetter = () => Promise<QRProps<QRDataType>>;
